export default "__VITE_ASSET__8c62e53d__"